import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import type { SelectProps } from 'antd'
import { getCountries } from 'react-phone-number-input'

const CountrySelect = ({ countryCode, setCountryCode }: any) => {
	const countries = getCountries()

	const [options, setOptions] = useState<SelectProps['options']>([])
	useEffect(() => {
		if (countries) {
			const newOptions = countries?.map((group: any, index: any) => {
				return {
					value: index.toString(),
					label: group,
				}
			})
			setOptions(newOptions)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleChange = (value: any, label) => {
		setCountryCode(label?.label)
	}
	return (
		<Select
			placeholder={countryCode}
			onChange={handleChange}
			filterOption
			options={options}
			style={{ width: '100%' }}
		/>
	)
}

export default CountrySelect
